import React from 'react';

interface LicenseModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WHATSAPP_NUMBER = '5491157611750';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const LicenseModal: React.FC<LicenseModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-0 md:p-4 z-[60] overflow-y-auto"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="relative bg-white rounded-none md:rounded-xl w-full h-full md:h-auto max-w-lg md:mt-24 md:mb-8 shadow-lg flex flex-col animate-in fade-in zoom-in duration-200">
        <div className="flex justify-between items-center border-b p-4 md:p-6 bg-white rounded-t-xl">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">Licencias</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 min-w-[44px] min-h-[44px] flex items-center justify-center text-2xl md:text-xl touch-manipulation"
          >
            ✕
          </button>
        </div>

        <div className="p-4 md:p-8">
          <p className="text-gray-600 text-sm md:text-base mb-6">
            Contactate con un asesor para darte de baja.
          </p>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center px-4 py-2.5 bg-gray-100 text-gray-600 text-sm rounded-lg border border-gray-200 hover:bg-gray-200 transition-colors"
          >
            Contactar por WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default LicenseModal;
